export default {
    Clinics: 'clinics',
    Doctors: 'doctors',
}
